 

export enum ProFormaModelIds {
    APARTMENT = 1,
    INDUSTRIAL = 2,
    RETAIL = 3,
    OFFICE = 4,
    DATA_CENTER = 5,
    APARTMENT_WITH_RETAIL = 6,
    STUDENT_HOUSING = 7,
    LAND_DEVELOPMENT = 8,
    RESIDENTIAL_CONDO = 9,
    HOTEL_HOSPITALITY = 10,
    SELF_STORAGE = 11
}

export enum IncomeCalculationType {
    ESTIMATE = 'estimate',
    TENANTS = 'tenants',
}

export const PRO_FORMA_MODELS_WITH_LEASING_COST_RESERVES = [
    ProFormaModelIds.INDUSTRIAL,
    ProFormaModelIds.RETAIL,
    ProFormaModelIds.OFFICE,
    ProFormaModelIds.APARTMENT_WITH_RETAIL,
];

export const KEY_STATS_LABELS = {
    EXIT_VALUATION: 'Exit valuation',
    LEVERED_IRR: 'Levered IRR',
    LEVERED_EMX: 'Levered EMx',
    STAB_YIELD_ON_COST: 'Stab. yield-on-cost',
    EQUITY_PROCEEDS: 'Equity proceeds',
} as const;

export type KeyStatsLabel = typeof KEY_STATS_LABELS[keyof typeof KEY_STATS_LABELS];
